import { createSelector } from 'reselect';
import { eventsStateFiltered } from 'console/tabs/events/utils';
const emptyFilter = {};
export const select_is_any_event = createSelector((state, device_id) => device_id ? state.events[device_id]?.batches ?? [] : [], (state) => state.ui_settings.event_filter ?? emptyFilter, (state) => !!state?.account.show_network_events, (batches, event_filter, show_network_events) => batches.some((batch) => batch.localizedEvents.some((event) => eventsStateFiltered(event_filter, show_network_events, event))));
export const select_device_events = createSelector((state, device_id) => device_id && state.events[device_id]
    ? state.events[device_id]
    : {
        loading: false,
        loaded: false,
        error: null,
        batches: [],
        have_more: false,
    }, (events) => events);
